import { ServiceResponse } from "~/api/api.types";
import { SignupRequest, User } from "~/domains/user/models/user";
import { api, web } from "./axios";

export type SignUpPath = "sign-up" | "sign-up-uhc";

export const signup = async ({
  signupRequest,
  reCaptchaToken,
  path,
}: {
  signupRequest: SignupRequest;
  reCaptchaToken: string;
  path: SignUpPath;
}) => {
  const response = await api.post<ServiceResponse<User>>(
    `/${path}`,
    signupRequest,
    {
      headers: {
        "g-recaptcha-token": reCaptchaToken,
      },
    },
  );
  return response.data;
};

interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  tokenType: string;
  redirectTo?: string;
}

export const sendOtp = async ({
  email,
  reCaptchaToken,
}: {
  email: string;
  reCaptchaToken: string;
}) => {
  const response = await api.post<{ message: string }>(
    "/otp",
    { email },
    { headers: { "g-recaptcha-token": reCaptchaToken } },
  );
  return response.data;
};

interface VerifyOtpRequest {
  email: string;
  code: string;
  clientId?: string | null;
  redirectUri?: string | null;
  responseType?: string | null;
  scope?: string | null;
  state?: string | null;
}

export const verifyOtp = async (request: VerifyOtpRequest) => {
  const response = await api.post<ServiceResponse<LoginResponse>>(
    "/otp/login",
    request,
  );
  return response.data;
};

export const fetchCsrfToken = async () => {
  const response = await web.get("/sanctum/csrf-cookie");
  return response.data;
};

export interface SessionParams {
  clientId: string;
  redirectUri: string;
  responseType: string;
  scope: string;
  state: string;
}

export const verifySession = async (verifySessionParams?: SessionParams) => {
  const params = { ...verifySessionParams };
  const response = await web.get<ServiceResponse<LoginResponse>>(
    "/auth/status",
    { params },
  );
  return response.data;
};

export const refreshToken = async (token: string) => {
  const response = await api.post<ServiceResponse<LoginResponse>>(
    "/refresh-token",
    {},
    { headers: { "Refresh-Token": token } },
  );

  return response.data;
};

export const emailVerificationLogin = async (params: {
  email: string;
  otpVerificationToken: string;
}) => {
  const response = await api.post<ServiceResponse<LoginResponse>>(
    "/email-verification/login",
    {
      email: params.email,
      otp_verification_token: params.otpVerificationToken,
    },
  );
  return response.data;
};

export const tokenLogin = async (params: { email: string; token: string }) => {
  const response = await api.post<ServiceResponse<LoginResponse>>(
    "/auth/token-login",
    {
      email: params.email,
      token: params.token,
    },
  );
  return response.data;
};

export const logout = async () => {
  await api.post<void>("/logout");
};
